import queryString from 'query-string';
import conf from '../config';
import { getOrganization } from './users';

const initialState = {
  products: {},
};

const ADD_PRODUCT = 'ADD_PRODUCT';
const SET_PRODUCTS = 'SET_PRODUCTS';
const CLEAR_DATA = 'CLEAR_DATA';

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      const newProducts = Object.assign({}, state.products, {
        [action.payload._id]: action.payload,
      });
      return { ...state, products: newProducts };
    case SET_PRODUCTS:
      const products = action.payload.reduce((acc, el) => {
        acc[el._id] = el;
        return acc;
      }, {});
      return { ...state, products };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const getProducts = (state) => state.products.products;

const setProducts = (products) => ({
  type: SET_PRODUCTS,
  payload: products,
});

export const creatProduct = (attrs) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  attrs.organization = organization && organization.slug;
  const result = await fetch(`${conf.apiRoot}/api/products`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(attrs),
  }).then((res) => {
    if (res.status === 500) return null;
    return res.json();
  });
  console.log(result);
  if (result && result.status === 'ok') {
    dispatch(addProduct(result.model));
  }
  return result;
};

export const updateProduct = (id, update) => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  update.organization = organization && organization.slug;
  const result = await fetch(`${conf.apiRoot}/api/products/${id}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(update),
  }).then((res) => {
    if (res.status === 500) return null;
    return res.json();
  });
  if (result && result.status === 'ok') {
    dispatch(addProduct(result.model));
  }
  return result;
};

export const fetchProducts = () => async (dispatch, getState) => {
  const state = getState();
  const products = getProducts(state);
  const organization = getOrganization(state);
  const query = { organization: organization && organization.slug };
  if (Object.keys(products).length) return products;
  const results = await fetch(
    `${conf.apiRoot}/api/products?${queryString.stringify(query)}`,
    {
      credentials: 'include',
    }
  ).then((res) => {
    if (res.status === 500) return null;
    return res.json();
  });

  if (results) {
    for (let i in results) {
      results[i].materials = results[i].materials || [];
    }
    dispatch(setProducts(results));
  }
  return results;
};

export const addProduct = (product) => ({
  type: ADD_PRODUCT,
  payload: product,
});



// WEBPACK FOOTER //
// ./src/modules/productFamily.js